<template>
  <div>
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow-sm border-bottom" id="navbar-main">
      <div class="container-fluid">
        <div>
          <p class="text-uppercase text-muted mb-1 super-page-kicker">Configuration</p>
          <h2 class="h3 mb-0">Site Management</h2>
        </div>
        <user-data></user-data>
      </div>
    </nav>

    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body py-4">
          <div class="row align-items-end">
            <div class="col-lg-7 mb-3 mb-lg-0">
              <p class="super-page-kicker mb-2">Sites</p>
              <h3 class="mb-2">Review and maintain configured sites</h3>
              <p class="text-muted mb-0">
                Search current results, inspect lot details, and update site configuration from one page.
              </p>
            </div>
            <div class="col-lg-5">
              <div class="row align-items-end">
                <div class="col-md-8 mb-3 mb-md-0">
                  <label class="form-control-label">Search</label>
                  <b-form-input v-model.trim="searchTerm" placeholder="Site, provider, or service"></b-form-input>
                </div>
                <div class="col-md-4 text-md-right">
                  <router-link :to="{ name: 'addNewSite' }" class="btn btn-primary btn-block">Add Site</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm border-0">
        <div class="card-header bg-white border-0 py-3">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">Site List</h3>
            <span class="badge badge-pill badge-primary">{{ filteredSites.length }} visible</span>
          </div>
        </div>

        <div v-if="isBusy" class="text-center py-6">
          <b-spinner variant="primary" class="mb-3"></b-spinner>
          <p class="text-muted mb-0">Loading sites...</p>
        </div>

        <div v-else-if="filteredSites.length" class="table-responsive">
          <b-table class="mb-0" striped hover :items="filteredSites" :fields="fields">
            <template slot="index" slot-scope="data">
              {{ data.index + (siteList.from || 1) }}
            </template>
            <template slot="site_mapping" slot-scope="data">
              {{ data.value.name }}
            </template>
            <template slot="provider_name" slot-scope="data">
              {{ data.value.name }}
            </template>
            <template slot="service_type" slot-scope="data">
              {{ data.value.service_name }}
            </template>
            <template slot="meter_count" slot-scope="data">
              {{ data.value }}
            </template>
            <template slot="actions" slot-scope="data">
              <div class="d-flex justify-content-center align-items-center" style="gap: 0.4rem;">
                <b-button size="sm" variant="outline-primary" @click="editSite(data.item)">Edit</b-button>
                <b-button size="sm" variant="outline-secondary" @click="viewSite(data.item)">Lots</b-button>
              </div>
            </template>
          </b-table>
          <div class="card-footer border-0 bg-white">
            <b-pagination align="right" @input="pageClick" :total-rows="siteList.total || 0"
              v-model="currentPage" :per-page="10">
            </b-pagination>
          </div>
        </div>

        <div v-else class="text-center py-6">
          <h5 class="mb-2">No records found</h5>
          <p class="text-muted mb-0">Try another search term or add a site.</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import userData from '@/pages/Common/userData';

export default {
  components: {
    userData
  },
  data() {
    return {
      currentPage: 1,
      isBusy: false,
      searchTerm: '',
      fields: [
        { key: 'index', label: 'S.No', sortable: true, class: 'text-center' },
        { key: 'site_mapping', label: 'Name', sortable: true, class: 'text-center' },
        { key: 'provider_name', label: 'Service Provider', sortable: true, class: 'text-center' },
        { key: 'service_type', label: 'Meter Type', sortable: true, class: 'text-center' },
        { key: 'meter_count', label: 'Meter Count', sortable: true, class: 'text-center' },
        { key: 'actions', label: 'Actions', sortable: false, class: 'text-center' }
      ]
    }
  },
  computed: {
    ...mapGetters('siteManagement', ['siteList']),
    filteredSites() {
      const searchTerm = this.searchTerm.toLowerCase()
      const siteRows = this.siteList && this.siteList.data ? this.siteList.data : []
      if (!searchTerm) {
        return siteRows
      }
      return siteRows.filter((item) => {
        const siteName = item.site_mapping && item.site_mapping.name ? item.site_mapping.name.toLowerCase() : ''
        const providerName = item.provider_name && item.provider_name.name ? item.provider_name.name.toLowerCase() : ''
        const serviceName = item.service_type && item.service_type.service_name ? item.service_type.service_name.toLowerCase() : ''
        return siteName.includes(searchTerm) || providerName.includes(searchTerm) || serviceName.includes(searchTerm)
      })
    }
  },
  methods: {
    ...mapActions('siteManagement', ['SITE_LIST']),
    getSiteList(page = this.currentPage) {
      this.isBusy = true
      this.SITE_LIST(page)
        .then(() => {
          this.currentPage = page
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    pageClick(page) {
      this.getSiteList(page)
    },
    viewSite(data) {
      this.$router.replace({
        name: 'siteDetailView',
        params: {
          serviceproviderid: data.provider_name.id,
          servicetypeid: data.service_type_id,
          siteid: data.site_id
        }
      })
    },
    editSite(data) {
      this.$store.commit('siteManagement/setSiteForEdit', data)
      this.$router.replace({
        name: 'siteEdit',
        params: {
          serviceproviderid: data.provider_name.id,
          servicetypeid: data.service_type_id,
          siteid: data.site_id
        }
      })
    }
  },
  created() {
    this.getSiteList(1)
  }
}
</script>

<style scoped>
.super-page-kicker {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #5e72e4;
}

</style>



// WEBPACK FOOTER //
// src/pages/SuperAdmin/siteManagement.vue